import { getUserRequest } from "../../api/user";
import { useCookies } from 'vue3-cookies';

const { cookies } = useCookies();

const state = () => ({
  user: {
    cookiePolicyConfirm: false
  },
  isLoggedIn: cookies.isKey('token'),
  isNotaryLoggedIn: cookies.isKey('tokenNotary'),
  display: false,
  routeTo: '/orders'
});

const getters = {
  getUser (state) {
    return state.user;
  }
};

const actions = {
  getUser({ commit }) {
    return getUserRequest().then(response => {
      commit('setUser', response.data.data);
    });
  }
};

const mutations = {
  setUser (state, value) {
    state.user = value;
    state.isLoggedIn = true;
  },
  clearUser (state) {
    state.isLoggedIn = false;
    state.user = {
      cookiePolicyConfirm: false
    };
  },
  showAuth (state, payload) {
    state.display = true;
    if(payload && payload.to) {
      state.routeTo = payload.to;
    }
  },
  hideAuth (state) {
    state.display = false;
    state.routeTo = null
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
